import { css } from '@emotion/react';
import { useEffect, useRef } from 'react';

const CHECKBOX_STYLE = css`
  label: CHECKBOX_STYLE;
  width: 20px;
  height: 20px;
  border: 1px solid var(--border);
  display: flex;
  cursor: pointer;
  border-radius: 0 !important;
`;

const CHECKBOX_CHECKED_STYLE = css`
  label: CHECKBOX_CHECKED_STYLE;
  background: var(--backgroundGreen3);
`;

type CheckboxProps = {
  indeterminate?: boolean;
} & Omit<React.HTMLProps<HTMLInputElement>, 'type'>;

/**
 * A standard HTML checkbox input, but also supporting an `indeterminate` prop.
 */
export const Checkbox = ({ indeterminate, ...props }: CheckboxProps) => {
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const el = input.current;
    if (!el) return;
    el.indeterminate = !!indeterminate;
  }, [indeterminate]);

  return <input ref={input} type='checkbox' {...props} css={[CHECKBOX_STYLE, props.checked && CHECKBOX_CHECKED_STYLE]} />;
};
